// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Util_I18n = require("../../util/Util_I18n.bs.js");
var Type_String = require("../../type/Type_String.bs.js");

function getBadgeURl(store, locale) {
  return "/footer/badges/" + store + "_" + Util_I18n.localeToString(locale) + ".png";
}

function make(image, cdnUrl) {
  var __x;
  if (typeof image === "number") {
    switch (image) {
      case /* AfterRightVOD */0 :
          __x = "/artevod.png";
          break;
      case /* Background500 */1 :
          __x = "/500/background.jpeg";
          break;
      case /* Error500 */2 :
          __x = "/500/title.png";
          break;
      case /* EuropeanFlag */3 :
          __x = "/footer/europe.png";
          break;
      case /* NewsletterZone */4 :
          __x = "/newsletter.jpg";
          break;
      case /* User */5 :
          __x = "/myarte/next-profile.png";
          break;
      
    }
  } else {
    switch (image.TAG | 0) {
      case /* Badge */0 :
          __x = getBadgeURl(image._0, image._1);
          break;
      case /* BuyProgram */1 :
          __x = image._0 ? "/program/artenovod.png" : "/program/artevod.png";
          break;
      case /* Newsletter */2 :
          __x = "/newsletter/newsletter_" + Util_I18n.localeToString(image._0) + ".png";
          break;
      case /* Profile */3 :
          __x = image._0 ? "/myarte/ident_arte_mobile.jpg" : "/myarte/ident_arte_desktop.jpg";
          break;
      
    }
  }
  return Type_String.CdnUrl.addPath(cdnUrl, __x);
}

exports.getBadgeURl = getBadgeURl;
exports.make = make;
/* No side effect */
